const KNOWN_ROW_REASONS = [
  "tank_over_capacity",
  "tank_full_mismatch",
  "fuel_without_meter_progress",
];

function anomalyByKind(item) {
  const byKind = {};
  (item.anomalies || []).forEach((anomaly) => {
    if (anomaly && anomaly.kind && !byKind[anomaly.kind]) {
      byKind[anomaly.kind] = anomaly;
    }
  });
  return byKind;
}

function fallbackFuelings(item, byKind) {
  const rows = [];
  const mismatch = byKind.tank_full_mismatch;
  const stuck = byKind.fuel_without_meter_progress;
  if (mismatch && mismatch.previousLiters != null) {
    rows.push({
      role: "previous",
      at: null,
      liters: mismatch.previousLiters,
      hourMeter:
        stuck && stuck.previousMeterReading != null
          ? stuck.previousMeterReading
          : null,
      tankFull: null,
    });
  } else if (stuck && stuck.previousMeterReading != null) {
    rows.push({
      role: "previous",
      at: null,
      liters: null,
      hourMeter: stuck.previousMeterReading,
      tankFull: null,
    });
  }
  rows.push({
    role: "current",
    at: item.finishedAt || null,
    liters: item.liters,
    hourMeter: item.hourMeter,
    tankFull: Boolean(mismatch),
    operatorId: item.operatorId || null,
    operatorName: item.operatorName || "",
  });
  return rows;
}

function normalizeFuelings(item, byKind) {
  const fuelings = Array.isArray(item.fuelings) ? item.fuelings : [];
  if (!fuelings.length) return fallbackFuelings(item, byKind);
  return fuelings.map((fueling) => ({
    role: fueling.role === "previous" ? "previous" : "current",
    at: fueling.at || null,
    liters: fueling.liters,
    hourMeter: fueling.hourMeter,
    tankFull: fueling.tankFull == null ? null : Boolean(fueling.tankFull),
    operatorId: fueling.operatorId || null,
    operatorName: fueling.operatorName || "",
  }));
}

export function buildFuelSupplySheet(item) {
  const source = item || {};
  const byKind = anomalyByKind(source);
  const over = byKind.tank_over_capacity || null;
  const mismatch = byKind.tank_full_mismatch || null;
  const stuck = byKind.fuel_without_meter_progress || null;
  const otherKinds = (source.anomalies || [])
    .map((anomaly) => anomaly && anomaly.kind)
    .filter((kind) => kind && !KNOWN_ROW_REASONS.includes(kind));

  const tankCapacity =
    source.tankCapacity != null ? Number(source.tankCapacity) : null;
  const stuckReading =
    stuck && stuck.meterReading != null ? Number(stuck.meterReading) : null;

  const rows = normalizeFuelings(source, byKind).map((fueling, index) => {
    const isCurrent = fueling.role === "current";
    const liters = fueling.liters == null ? null : Number(fueling.liters);
    const meter = fueling.hourMeter == null ? null : Number(fueling.hourMeter);
    const aboveTank =
      tankCapacity != null && liters != null && liters > tankCapacity;
    const reasons = [];
    let litersStatus = liters == null ? "neutral" : "ok";
    let meterStatus = meter == null ? "neutral" : "ok";
    let tankStatus = fueling.tankFull == null ? "neutral" : "ok";

    if (aboveTank) {
      litersStatus = "bad";
      reasons.push("over_capacity");
    } else if (!isCurrent && mismatch) {
      litersStatus = "info";
      reasons.push("used_in_sum");
    }
    if (stuck && meter != null && stuckReading != null && meter === stuckReading) {
      meterStatus = "bad";
      reasons.push(isCurrent ? "meter_stuck" : "meter_reference");
    }
    if (isCurrent && mismatch) {
      tankStatus = "bad";
      reasons.push("tank_full_sum");
    } else if (fueling.tankFull && aboveTank) {
      tankStatus = "bad";
    }
    if (isCurrent) {
      otherKinds.forEach((kind) => reasons.push(kind));
    }

    const overall = [litersStatus, meterStatus, tankStatus].includes("bad")
      ? "bad"
      : "ok";

    return {
      key: `${fueling.role}-${index}`,
      ...fueling,
      litersStatus,
      meterStatus,
      tankStatus,
      reasons,
      overall,
    };
  });

  return {
    rows,
    over,
    mismatch,
    stuck,
    otherKinds,
    tankCapacity: source.tankCapacity,
  };
}
